import { Grid } from '@mui/material'
import React from 'react'
import DashboardEngagementCard from '../DashboardEngagementCard/DashboardEngagementCard'
import DashboardSessionCard from '../DashboardSessionCard/DashboardSessionCard'
import DashboardStatCard from '../DashboardStatCard/DashboardStatCard'
import {
  type CoachStatsResponse,
  type AsyncStateObject,
  type CoachSessionSummaryDto,
  type RecentEngagementAsCoachResponse,
  type DashboardStatChartDto,
  type DashboardRecentEngagementDto,
  type DashboardSessionSummaryDto,
  type CoachGoalSummaryDto,
  type DashboardGoalSummaryDto,
  type DropdownOptionnDto
} from '../../../interfaces'
import DashboardStatChartCard from '../DashboardStatChartCard/DashboardStatChartCard'
import DashboardGoalSummaryCard from '../DashboardGoalSummaryCard/DashboardGoalSummaryCard'
import { ENGAGEMENT_TYPES } from '../../../utils/constants'

const DashboardCoachView: React.FC<{
  goalStatus: DropdownOptionnDto
  onHandleStatusChange: (value: DropdownOptionnDto) => void
  coachStatsResponse: AsyncStateObject<CoachStatsResponse | null>
  recentCoachEngagementResponse: AsyncStateObject<RecentEngagementAsCoachResponse | null>
  coachSessionSummaryDataResponse: AsyncStateObject<CoachSessionSummaryDto[]>
  coachGoalSummaryDataResponse: AsyncStateObject<CoachGoalSummaryDto[]>
}> = ({
  goalStatus,
  onHandleStatusChange,
  coachStatsResponse,
  recentCoachEngagementResponse,
  coachSessionSummaryDataResponse,
  coachGoalSummaryDataResponse
}) => {
  const engagements = coachStatsResponse?.data?.engagements
  const goals = coachStatsResponse?.data?.goals
  const chartData: DashboardStatChartDto = {
    total: goals?.totalGoals ?? 0,
    pending: goals?.pendingGoals ?? 0,
    rejected: goals?.rejectedGoals ?? 0,
    accepted: goals?.acceptedGoals ?? 0,
    assigned: goals?.assignedGoals ?? 0,
    inProgress: goals?.inProgressGoals ?? 0,
    completed: goals?.completedGoals ?? 0
  }

  const recentEngagementData = recentCoachEngagementResponse?.data
  const engagementData: DashboardRecentEngagementDto = {
    _id: recentEngagementData?._id ?? '',
    name: recentEngagementData?.name ?? '',
    endDate: recentEngagementData?.endDate ?? '',
    totalSessions: recentEngagementData?.totalSessions ?? 0,
    sessionsLeft: recentEngagementData?.sessionsLeft ?? 0,
    sessionCompletedPercentage: recentEngagementData?.sessionCompletedPercentage ?? 0.0,
    coaches: recentEngagementData?.coaches ?? []
  }

  const recentSessions = coachSessionSummaryDataResponse?.data ?? []
  const recentSessionsList: DashboardSessionSummaryDto[] = recentSessions.map((session) => {
    return {
      engagementId: session.engagementId,
      sessionId: session.sessionId,
      name: session.name,
      sessionType: session.sessionType,
      sessionDuration: session.sessionDuration,
      status: session.status
    }
  })

  const recentGoals = coachGoalSummaryDataResponse?.data ?? []
  const recentGoalsList: DashboardGoalSummaryDto[] = recentGoals.map((goal) => {
    return {
      _id: goal._id,
      name: goal.name,
      priority: goal.priority,
      priorityId: goal.priorityId,
      startDate: goal.startDate,
      endDate: goal.endDate,
      status: goal.status,
      statusId: goal.statusId
    }
  })
  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12} lg={8}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6} lg={3}>
              <DashboardStatCard
                isLoading={coachStatsResponse?.isLoading}
                count={engagements?.totalEngagements ?? 0}
                title={'Total Engagements'}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <DashboardStatCard
                isLoading={coachStatsResponse?.isLoading}
                count={engagements?.completedEngagements ?? 0}
                title={'Completed Engagements'}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <DashboardStatCard
                isLoading={coachStatsResponse?.isLoading}
                count={engagements?.inProgressEngagements ?? 0}
                title={'In Progress Engagements'}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <DashboardStatCard
                isLoading={coachStatsResponse?.isLoading}
                count={engagements?.pendingEngagements ?? 0}
                title={'Pending Engagements'}
              />
            </Grid>
            <Grid item xs={12}>
              <DashboardStatChartCard
                title='Total Goals Created'
                isLoading={coachStatsResponse?.isLoading}
                data={chartData}
                showAction={false}
              />
            </Grid>
            <Grid item xs={12}>
              <DashboardGoalSummaryCard
                selectedStatus={goalStatus}
                onChange={onHandleStatusChange}
                isLoading={coachGoalSummaryDataResponse?.isLoading}
                data={recentGoalsList}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} lg={4}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <DashboardEngagementCard
                isLoading={recentCoachEngagementResponse?.isLoading}
                data={engagementData}
                type={ENGAGEMENT_TYPES.COACH}
              />
            </Grid>
            <Grid item xs={12}>
              <DashboardSessionCard
                isLoading={coachSessionSummaryDataResponse?.isLoading}
                data={recentSessionsList}
                type={ENGAGEMENT_TYPES.COACH}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  )
}

export default DashboardCoachView
